import { z } from 'zod';

import { Temperature } from '../fields/Temperature';

import { TerminalTorque } from './Terminal.Torque';
import { TerminalType } from './Terminal.Type';

const validator = z
    .object({
        temperature: Temperature.validator,
        type: TerminalType.validator,
        torque: TerminalTorque.validator,
    })
    .default({});

export const Terminal = {
    validator,
};
